/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { SurveyFieldDto } from './survey-field-dto';
/**
 *
 *
 * @export
 * @interface SurveyCreationDraftDto
 */
export interface SurveyCreationDraftDto {
  /**
   * Working name of the survey.
   *
   * @type {string}
   * @memberof SurveyCreationDraftDto
   * @example Patient Satisfaction Survey (WIP)
   */
  name?: string;

  /**
   * Description of the survey.
   *
   * @type {string}
   * @memberof SurveyCreationDraftDto
   * @example A survey to measure patient satisfaction after each visit.
   */
  description?: string;

  /**
   * Study this survey belongs to.
   *
   * @type {string}
   * @memberof SurveyCreationDraftDto
   * @example clinical-trial-2024
   */
  study?: string;

  /**
   * Template defining the fields to fill in the survey.
   *
   * @type {Array<SurveyFieldDto>}
   * @memberof SurveyCreationDraftDto
   */
  template: Array<SurveyFieldDto>;

  /**
   * Priority level of the survey.
   *
   * @type {string}
   * @memberof SurveyCreationDraftDto
   * @example mandatory
   */
  priority?: SurveyCreationDraftDtoPriorityEnum;

  /**
   * How often the survey should be sent, in days.
   *
   * @type {number}
   * @memberof SurveyCreationDraftDto
   * @example 30
   */
  send_frequency_days?: number;

  /**
   * Number of days the participant has to submit a response.
   *
   * @type {number}
   * @memberof SurveyCreationDraftDto
   * @example 7
   */
  response_time_limit_days?: number;

  /**
   * Date when the survey becomes active (ISO 8601).
   *
   * @type {string}
   * @memberof SurveyCreationDraftDto
   * @example 2026-08-01T00:00:00.000Z
   */
  starts_at?: string;

  /**
   * Type of the anonymization.
   *
   * @type {string}
   * @memberof SurveyCreationDraftDto
   * @example none
   */
  anonymization_type?: SurveyCreationDraftDtoAnonymizationTypeEnum;

  /**
   * Defines who in the organization should receive the survey.
   *
   * @type {string}
   * @memberof SurveyCreationDraftDto
   * @example all_users
   */
  send_strategy?: SurveyCreationDraftDtoSendStrategyEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum SurveyCreationDraftDtoPriorityEnum {
  Mandatory = 'mandatory',
  Optional = 'optional',
}
/**
 * @export
 * @enum {string}
 */
export enum SurveyCreationDraftDtoAnonymizationTypeEnum {
  None = 'none',
  AllAnswers = 'all_answers',
  Optional = 'optional',
}
/**
 * @export
 * @enum {string}
 */
export enum SurveyCreationDraftDtoSendStrategyEnum {
  AllUsers = 'all_users',
  AdminOnly = 'admin_only',
}
